@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

.inline-tab-button {
  border: 0;
  border-bottom: @space-4 solid transparent;
  border-radius: 0;
  transition: border-bottom 0.3s ease-in-out;
}

.inline-tab-button-selected {
  border-bottom: @space-4 solid var(--blue-600);
  color: var(--blue-600);

  &:hover {
    color: var(--blue-600);
  }
}
